import Base from './base'
import { FieldsOrderResponse, FieldType } from '../types/fieldsOrders'

export default class FieldsOrders extends Base {
  getFieldsOrder(fieldType: FieldType): Promise<FieldsOrderResponse> {
    return this.api.get(`fields_orders?field_type=${fieldType}`)
  }
}
